import React from "react";
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input/input';
import SelectorTwoLine from '@/SelectorTwoLine';

export const checkboxField = ({ className = 'col mb-3', get, getError, set, key, index, label, name }) => {
	const error = getError ? getError({ key, index, name }) : false;
	return (
		<div className={className}>
			<div className="form-check">
				{label &&
					<label className="form-check-label small">
						<input className={`form-check-input ${error ? 'is-invalid' : ''}`} defaultChecked={get({ key, index, name })} name={name} onChange={event => set({ key, index, name, value: event.target.checked ? true : false })} type="checkbox" />
						<b>{label}</b>
					</label>
				}
				<div className="invalid-feedback">{error}</div>
			</div>
		</div>
	);
};

export const dateField = ({ className = 'col mb-3', disabled, inputClassName = '', get, getError, set, key, index, label, name }) => {
	const error = getError ? getError({ key, index, name }) : false;
	return (
		<div className={className}>
			<div className="form-group">
				{label && <label className="small"><b>{label}</b></label>}
				<input
					aria-invalid="false"
					className={`mb-2 mt-2 form-control ${inputClassName} ${error ? 'is-invalid' : ''}`}
					defaultValue={get({ key, index, name })}
					disabled={disabled}
					onChange={e => set({ key, index, name, value: e.target.value })}
					type="date"
				/>
				<div className="invalid-feedback">{error}</div>
			</div>
		</div>
	);
};

export const selectField = ({ className = "col mb-3", defaultOptions, disabled, extraKeys, get, getData, getError, idKey, isMulti = false, isOptionDisabled, placeholder, set, key, index, label, label1Key = 'label', label2Key, name, options, onRemove, setOptions, valueKey = 'id' }) => {
	const error = getError ? getError({ key, index, name }) : false;
	let defaultValue = get({ key, index, name });
	if (defaultValue === null || typeof defaultValue !== 'object') {
		// Convert it to an option element using either supplied options or defaultOptions
		// Note: This defaultOptions is just meant for here, the initial conversion of id to object.
		// Not passed into SelectorTwoLine.
		if (isMulti) {
			const _defaultValue = Array.isArray(defaultValue) ? defaultValue : (defaultValue === null ? [null] : (defaultValue || '').split(''));
			defaultValue = (options || defaultOptions || []).filter(e => (_defaultValue || []).find(f => f === e[valueKey]));
		} else {
			defaultValue = (options || defaultOptions || []).find(e => e[valueKey] === defaultValue);
		}
	}
	const onChange = (option, actionMeta) => {
		if (['remove-value', 'pop-value'].indexOf(actionMeta.action) !== -1) {
			onRemove && onRemove({ idKey, key, value: actionMeta.removedValue, valueKey });
		} else if (actionMeta.action === 'clear') {
			// Issue a call with all: true
			onRemove && onRemove({ all: true, key });
		}
		const value = Array.isArray(option) ? option.map(e => e[valueKey]).join('') : option[valueKey];
		set({ key, index, name, option, value });
	};
	return (
		<div className={className}>
			<div className="form-group">
				{label && <label className="small mb-2"><b>{label}</b></label>}
				<SelectorTwoLine
					className={`form-control m-0 p-0 ${error ? 'is-invalid' : ''}`}
					defaultValue={defaultValue}
					disabled={disabled}
					extraKeys={extraKeys}
					getData={getData}
					idKey={idKey}
					isMulti={isMulti}
					isOptionDisabled={isOptionDisabled}
					label1Key={label1Key}
					label2Key={label2Key}
					onChange={onChange}
					options={options}
					placeholder={placeholder}
					setOptions={setOptions}
					valueKey={valueKey}
				/>
				<div className="invalid-feedback">{error}</div>
			</div>
		</div>
	);
}; 

export const textField = ({ autoFocus, className = "col mb-3", disabled, get, getError, inputClassName = '', set, key, index, label, name, placeholder, value }) => {
	const error = getError ? getError({ key, index, name }) : false;
	const _value = value ? value : get({ key, index, name });
	return (
		<div className={className}>
			<div className="form-group">
				{label && <label className="small"><b>{label}</b></label>}
				{disabled ? (
					<span className={`bg-grey-ef mb-2 mt-2 form-control ${inputClassName} ${error ? 'is-invalid' : ''}`}>{_value}</span>
				) : (
					<input autoFocus={autoFocus} className={`mb-2 mt-2 form-control ${inputClassName} ${error ? 'is-invalid' : ''}`} defaultValue={_value} name={name} onChange={event => set({ key, index, name, value: event.target.value })} placeholder={placeholder} />
				)}
				<div className="invalid-feedback">{error}</div>
			</div>
		</div>
	);
};

export const textAreaField = ({ disabled, get, getError, rows, set, key, index, label, name }) => {
	const error = getError ? getError({ key, index, name }) : false;
	return (
		<div className="col mb-3">
			<div className="form-group">
				<label className="small"><b>{label}</b></label>
				<textarea className={`mb-2 mt-2 form-control ${error ? 'is-invalid' : ''}`} defaultValue={get({ key, index, name })} disabled={disabled} name={name} onChange={event => set({ key, index, name, value: event.target.value })} rows={rows} />
				<div className="invalid-feedback">{error}</div>
			</div>
		</div>
	);
};

export const phoneField = ({ className = 'col mb-3', disabled, get, getError, labelClassName = 'small', set, key, index, label, name }) => {
	const error = getError ? getError({ key, index, name }) : false;
	return (
		<div className={className}>
			<div className="form-group">
				<label className={labelClassName}><b>{label}</b></label>
				<PhoneInput className={`mb-2 mt-2 form-control ${error ? 'is-invalid' : ''}`} defaultCountry="US" disabled={disabled} name={name} onChange={value => set({ key, index, name, value: value || null })} value={get({ key, index, name })} />
				<div className="invalid-feedback">{error}</div>
			</div>
		</div>
	);
};

export const timeField = ({ get, getError, set, key, index, label, name }) => {
	const error = getError ? getError({ key, index, name }) : false;
	return (
		<div className="col mb-3">
			<div className="form-group">
				<label className="small"><b>{label}</b></label>
				<input
					aria-invalid="false"
					className={`mb-2 mt-2 form-control ${error ? 'is-invalid' : ''}`}
					defaultValue={get({ key, index, name })}
					onChange={e => set({ key, index, name, value: e.target.value })}
					type="time"
				/>
				<div className="invalid-feedback">{error}</div>
			</div>
		</div>
	);
};

export const InputField = ({ autoFocus, constraint = {}, defaultValue, icon, invalid, label, onChange, onKeyUp, row = true, type = 'text' }) => {
	const c = (
		<div className="col">
			<div className="form-group">
				<label className="small"><b>{label}</b></label>
				<div className="input-group mb-2">
					{icon}
					<input
						aria-invalid="false"
						autoFocus={autoFocus}
						className={`form-control ${invalid ? 'is-invalid' : ''}`}
						defaultValue={defaultValue || undefined}
						minLength={constraint.minLength}
						maxLength={constraint.maxLength}
						onChange={e => onChange && onChange(e.target.value)}
						onKeyUp={onKeyUp}
						type="text"
						>
					</input>
				</div>
				<div className="invalid-feedback">{invalid}</div>
			</div>
		</div>
	);
	return row ? (
		<div className="row mb-3">{c}</div>
	) : (
		c
	);
};
